"use client";

import React, { useState, useEffect } from "react";

const ScrollToTop: React.FC<{ variant?: boolean }> = ({ variant }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [bottomPosition, setBottomPosition] = useState("17rem");

  // Threshold in pixels for when the button appears
  const SCROLL_THRESHOLD = 300;
  const SCROLL_ADJUST_THRESHOLD = 500; // Adjust bottom when user scrolls up this much

  // Function to scroll to the top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Handle scroll event to toggle visibility and adjust position
  const handleScroll = () => {
    const scrollY = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    if (scrollY > SCROLL_THRESHOLD) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }

    // Check if user is at the bottom
    if (windowHeight + scrollY >= documentHeight - 50) {
      setBottomPosition("17rem");
    } else if (
      scrollY <
      documentHeight - windowHeight - SCROLL_ADJUST_THRESHOLD
    ) {
      setBottomPosition("1rem");
    }
  };

  // Add scroll event listener on mount, remove on unmount
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {isVisible && (
        <div
          className="flex bg-transparent z-50 flex-col gap-4 items-center fixed right-6 footer-item transition-all duration-300"
          style={{ bottom: bottomPosition }}
        >
          <div
            onClick={scrollToTop}
            className="bg-white rounded-xl grid place-items-center transition-all cursor-pointer size-[3.2rem] shadow-2xl duration-300"
            aria-label="Scroll to top"
          >
            <svg
              width="24"
              height="14"
              viewBox="0 0 24 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.02339 13.1152C1.90889 13.2234 1.7742 13.308 1.62701 13.3642C1.47983 13.4203 1.32302 13.4469 1.16555 13.4424C1.00808 13.438 0.853031 13.4026 0.709252 13.3382C0.565473 13.2738 0.435783 13.1817 0.327584 13.0673C0.219386 12.9528 0.1348 12.8181 0.0786539 12.6709C0.0225083 12.5237 -0.00409695 12.3669 0.00035765 12.2094C0.00481225 12.0519 0.0402392 11.8969 0.104616 11.7531C0.168993 11.6093 0.261058 11.4796 0.375556 11.3714L11.1692 1.17743C11.3919 0.966908 11.6867 0.849609 11.9931 0.849609C12.2996 0.849609 12.5944 0.966908 12.8171 1.17743L23.6119 11.3714C23.7289 11.4789 23.8234 11.6086 23.8899 11.7529C23.9563 11.8972 23.9935 12.0533 23.9991 12.2121C24.0048 12.3708 23.9788 12.5292 23.9227 12.6778C23.8667 12.8265 23.7816 12.9625 23.6726 13.078C23.5635 13.1936 23.4325 13.2862 23.2873 13.3507C23.1421 13.4152 22.9855 13.4502 22.8267 13.4537C22.6679 13.4571 22.5099 13.429 22.362 13.3709C22.2141 13.3128 22.0793 13.2259 21.9653 13.1152L11.9931 3.69835L2.02339 13.1152Z"
                fill="var(--primary-color)"
              />
            </svg>
          </div>

          {!variant && (
            <div className="scroll text-center font-semibold text-white">
              Back To <br /> Top
            </div>
          )}
        </div>
      )}
    </>
  );
};

export const ScrollToTop2: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [bottomPosition, setBottomPosition] = useState("17rem");

  // Threshold in pixels for when the button appears
  const SCROLL_THRESHOLD = 300;
  const SCROLL_ADJUST_THRESHOLD = 500; // Adjust bottom when user scrolls up this much

  // Function to scroll to the top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Handle scroll event to toggle visibility and adjust position
  const handleScroll = () => {
    const scrollY = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    if (scrollY > SCROLL_THRESHOLD) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }

    // Check if user is at the bottom
    if (windowHeight + scrollY >= documentHeight - 50) {
      setBottomPosition("8rem");
    } else if (
      scrollY <
      documentHeight - windowHeight - SCROLL_ADJUST_THRESHOLD
    ) {
      setBottomPosition("1rem");
    }
  };

  // Add scroll event listener on mount, remove on unmount
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {isVisible && (
        <div
          className="flex bg-transparent z-50 flex-col gap-4 items-center fixed left-[10rem] footer-item transition-all duration-300"
          style={{ bottom: bottomPosition }}
        >
          <div
            onClick={scrollToTop}
            className="bg-white rounded-full grid place-items-center transition-all cursor-pointer size-[3.2rem] shadow-2xl duration-300"
            aria-label="Scroll to top"
          >
            <svg
              width="24"
              height="14"
              viewBox="0 0 24 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.02339 13.1152C1.90889 13.2234 1.7742 13.308 1.62701 13.3642C1.47983 13.4203 1.32302 13.4469 1.16555 13.4424C1.00808 13.438 0.853031 13.4026 0.709252 13.3382C0.565473 13.2738 0.435783 13.1817 0.327584 13.0673C0.219386 12.9528 0.1348 12.8181 0.0786539 12.6709C0.0225083 12.5237 -0.00409695 12.3669 0.00035765 12.2094C0.00481225 12.0519 0.0402392 11.8969 0.104616 11.7531C0.168993 11.6093 0.261058 11.4796 0.375556 11.3714L11.1692 1.17743C11.3919 0.966908 11.6867 0.849609 11.9931 0.849609C12.2996 0.849609 12.5944 0.966908 12.8171 1.17743L23.6119 11.3714C23.7289 11.4789 23.8234 11.6086 23.8899 11.7529C23.9563 11.8972 23.9935 12.0533 23.9991 12.2121C24.0048 12.3708 23.9788 12.5292 23.9227 12.6778C23.8667 12.8265 23.7816 12.9625 23.6726 13.078C23.5635 13.1936 23.4325 13.2862 23.2873 13.3507C23.1421 13.4152 22.9855 13.4502 22.8267 13.4537C22.6679 13.4571 22.5099 13.429 22.362 13.3709C22.2141 13.3128 22.0793 13.2259 21.9653 13.1152L11.9931 3.69835L2.02339 13.1152Z"
                fill="var(--primary-color)"
              />
            </svg>
          </div>

          <div className="scroll text-center font-semibold text-white">
            Back To Top
          </div>
        </div>
      )}
    </>
  );
};
export default ScrollToTop;

export const ScrollToTop3: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [bottomPosition, setBottomPosition] = useState("17rem");

  // Threshold in pixels for when the button appears
  const SCROLL_THRESHOLD = 300;
  const SCROLL_ADJUST_THRESHOLD = 500; // Adjust bottom when user scrolls up this much

  // Function to scroll to the top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Handle scroll event to toggle visibility and adjust position
  const handleScroll = () => {
    const scrollY = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    if (scrollY > SCROLL_THRESHOLD) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }

    // Check if user is at the bottom
    if (windowHeight + scrollY >= documentHeight - 50) {
      setBottomPosition("17rem");
    } else if (
      scrollY <
      documentHeight - windowHeight - SCROLL_ADJUST_THRESHOLD
    ) {
      setBottomPosition("1rem");
    }
  };

  // Add scroll event listener on mount, remove on unmount
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {isVisible && (
        <div
          className="flex bg-transparent z-50 flex-col gap-4 items-center fixed right-0 footer-item transition-all duration-300"
          style={{ bottom: bottomPosition }}
        >
          <div
            onClick={scrollToTop}
            className="bg-white rounded-xl grid place-items-center transition-all cursor-pointer size-[3.2rem] shadow-2xl duration-300"
            aria-label="Scroll to top"
          >
            <svg
              width="24"
              height="14"
              viewBox="0 0 24 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.02339 13.1152C1.90889 13.2234 1.7742 13.308 1.62701 13.3642C1.47983 13.4203 1.32302 13.4469 1.16555 13.4424C1.00808 13.438 0.853031 13.4026 0.709252 13.3382C0.565473 13.2738 0.435783 13.1817 0.327584 13.0673C0.219386 12.9528 0.1348 12.8181 0.0786539 12.6709C0.0225083 12.5237 -0.00409695 12.3669 0.00035765 12.2094C0.00481225 12.0519 0.0402392 11.8969 0.104616 11.7531C0.168993 11.6093 0.261058 11.4796 0.375556 11.3714L11.1692 1.17743C11.3919 0.966908 11.6867 0.849609 11.9931 0.849609C12.2996 0.849609 12.5944 0.966908 12.8171 1.17743L23.6119 11.3714C23.7289 11.4789 23.8234 11.6086 23.8899 11.7529C23.9563 11.8972 23.9935 12.0533 23.9991 12.2121C24.0048 12.3708 23.9788 12.5292 23.9227 12.6778C23.8667 12.8265 23.7816 12.9625 23.6726 13.078C23.5635 13.1936 23.4325 13.2862 23.2873 13.3507C23.1421 13.4152 22.9855 13.4502 22.8267 13.4537C22.6679 13.4571 22.5099 13.429 22.362 13.3709C22.2141 13.3128 22.0793 13.2259 21.9653 13.1152L11.9931 3.69835L2.02339 13.1152Z"
                fill="var(--primary-color)"
              />
            </svg>
          </div>
        </div>
      )}
    </>
  );
};
